<template>
  <section>

    <b-row>
      <b-col md="12">
        <h2>Control de aforo</h2>
      </b-col>
    </b-row>

    <div class="mt-4">

      <b-tabs content-class="p-3" v-model="tabActual">

        <!-- Aforo en toda la institucion-->
        <b-tab title="Aforo general" active>

          <b-row class="mt-4 d-flex align-items-center">
            <b-col sm="3">
              <label for="input-none">Máximo aforo</label>
            </b-col>
            <b-col sm="9">
              <b-form-input id="input-none" type="number" v-model="numeroAforo" :state="null" placeholder="Ingrese el numero de personas" @keyup="actualizar()" debounce="200">
              </b-form-input>
            </b-col>
            <b-col class="d-flex flex-row-reverse mt-5">
              <b-button variant="success" @click="enviar()">Actualizar</b-button>
            </b-col>
          </b-row>

        </b-tab>

        <!-- Tab Tabla autorizacions por salon -->
        <b-tab title="Aforo por salon">

          <b-modal v-model="mainModal" size="lg" no-close-on-backdrop>
            <b-form ref="mainForm" @submit.prevent="limitarSalon()">
              <b-form-group label="Limite:" label-for="input-nombre">
                <b-form-input id="input-nombre" type="number" v-model="salon.limite" :state="null" placeholder="Ingrese el numero maximo de personas permitidas">
                </b-form-input>
              </b-form-group>
            </b-form>
            <template #modal-footer="{ cancel }">
              <b-button variant="success" @click="limitarSalon()">
                Actualizar limite
              </b-button>
              <b-button variant="danger" @click="cancel()">
                Eliminar Limite
              </b-button>
              <b-button variant="info" @click="cancel()">
                Cancelar
              </b-button>
            </template>
          </b-modal>

          <b-form ref="filtros" @submit.prevent="cargarRegistros">
            <b-form-row>
              <b-col md="4">
                <b-form-group label="Número:" label-for="input-filtro-numero">
                  <b-form-input id="input-filtro-numero" type="text" v-model="filtrosSalon.numero"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Descripción:" label-for="input-filtro-descripcion">
                  <b-form-input id="input-filtro-descripcion" type="text" v-model="filtrosSalon.descripcion"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-button variant="primary" type="submit">Filtrar</b-button>
              </b-col>
            </b-form-row>
          </b-form>

          <b-table responsive striped hover :items="registros" :fields="camposAutorizaciones">
            <template #cell(acciones)="row">
              <b-link href="" @click.prevent="editar(row.item)">Ajustar Limite</b-link>
            </template>
          </b-table>
          <!--
          <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
          -->

        </b-tab>

      </b-tabs>

    </div>

  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { url } from '../../../services/url_service'

@Component
export default class AjustesControlAcceso extends Vue {

  public dias: Array<any> = [
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo',
  ]

  public registros: Array<any> = []

  public page: number = 1
  public limit: number = 10
  public count: number = 0
  public filtrosSalon: any = {}
  public orden: any = {
    columna: 'fecha_inicio',
    direccion: 'ASC',
  }

  public pageErrores: number = 1
  public limitErrores: number = 10
  public countErrores: number = 0
  public errores: Array<any> = []

  public archivoHorarios: boolean = false
  public archivoCargando: boolean = false
  public adicionarArchivo: boolean = false
  public archivoRegistros: string = ''

  public numeroAforo: number = 0
  public tabActual: number = 0

  // Iniciales
  public numeroAforoInicial: number = 0
  public botonActivado: boolean = false
  public showOverlay: boolean = false


  public mainModal: boolean = false
  public erroresModal: any = {}
  public salon: any = {}


  public camposAutorizaciones: Array<any> = [
    {
      key: 'acciones',
      label: 'Acciones',
    },
    {
      key: 'NUMERO_SALON',
      label: 'Número',
    },
    {
      key: 'DESCRIPCION_SALON',
      label: 'Descripción',
    },
    {
      key: 'COD_EDIFICIO',
      label: 'Edificio',
    },
    {
      key: 'CAMPUS',
      label: 'Campus',
    },
    {
      key: 'LIMITE_LOCAL',
      label: 'Capacidad limite',
    },
    {
      key: 'CAPACIDAD_MAXIMA',
      label: 'Capacidad maxima',
    },
    {
      key: 'STATUS',
      label: 'Estado',
    },
  ]

  public async editar(salon) {

    this.mainModal = true
    this.salon = {
      codigo: salon.COD_EDIFICIO + "-" + salon.NUMERO_SALON,
      nombre: salon.NUMERO_SALON,
      maximo: salon.CAPACIDAD_MAXIMA,
      limite: salon.LIMITE_LOCAL,
    }
  }


  public async cargarRegistros() {

    this.registros = []

    let response = await axios.get(url.create('/internal/salones'), {
      params: this.filtrosSalon
    })
    var dataFin = response.data

    var responseLimite;
    var limites = [];

    try {

      responseLimite = await axios.get(url.create('/internal/salones/limites'))
      limites = responseLimite.data

    } catch (error) {
      console.error(error);
    }

    if (limites === null) {
      limites = []
    }

    for (var i = 0; i < dataFin.length; i++) {

      var limiteSalon = limites.find(salonLimitado => salonLimitado.codigo === (dataFin[i]["COD_EDIFICIO"] + "-" + dataFin[i]["NUMERO_SALON"])) ?? null;

      if (limiteSalon != null) {
        dataFin[i]["LIMITE_LOCAL"] = limiteSalon.limite;
      }

    }

    this.registros = dataFin;
  }


  public async cargarDatos() {

    try {
      // Hacerlo por post multiparametro - ToDo
      let response = await axios.get(url.create('/internal/parametros/aforo'))
      let data = response.data

      this.numeroAforo = data['valor']
      this.numeroAforoInicial = data['valor']
      this.archivoCargando = data['valor'] === 'true'


    } catch (error) {
      this.$bvToast.toast('No se pudieron cargar los datos', {
        title: 'Fallo en el servidor',
        variant: 'danger',
      })
    }
  }


  public actualizar() {
    this.botonActivado = this.numeroAforo != this.numeroAforoInicial ? true : false
  }

  public actualizarArchivo(adicionar = false) {
    this.archivoHorarios = false
    this.adicionarArchivo = adicionar
  }

  public async enviar() {

    if (this.numeroAforo != this.numeroAforoInicial) {
      let response = await axios.put(
        url.create('/internal/parametros/aforo'), {
        valor: this.numeroAforo
      })

      if (response.status == 200) {
        this.numeroAforoInicial = this.numeroAforo
        this.$bvToast.toast('Aforo actualizado', {
          title: 'Aforo actualizado',
          variant: 'success',
        })
      } else {
        this.$bvToast.toast('Ocurrio un error', {
          title: 'Aforo no actualizado',
          variant: 'danger',
        })
      }
    }

  }


  public async limitarSalon() {

    if (this.salon.limite != null && this.salon.codigo != null) {

      if ((this.salon.limite - this.salon.maximo) <= 0) {

        this.mainModal = false;

        this.cargarRegistros()

        let response = await axios.post(
          url.create('/internal/salones'), this.salon,
        )

        if (response.status == 200) {
          this.$bvToast.toast('Aforo de salon actualizado', {
            title: 'Aforo actualizado',
            variant: 'success',
          })
        } else {
          this.$bvToast.toast('Ocurrio un error', {
            title: 'Aforo no actualizado',
            variant: 'danger',
          })
        }

      } else {
        this.$bvToast.toast('El limite es mayor que el maximo', {
          title: 'Aforo no actualizado',
          variant: 'danger',
        })
      }

    } else {

      this.mainModal = false;

      this.$bvToast.toast('No se realizo ningun cambio', {
        title: 'Aforo no actualizado',
        variant: 'info',
      })

    }

  }


  @Watch('page')
  public pageChange(val) {
    this.cargarRegistros()
  }

  created() {
    this.cargarDatos()
    this.cargarRegistros()
  }
}
</script>

<style>
.tab-content {
  background-color: #ffffff;
}
</style>